import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as MesAct from '../../Actions/MesActions';
import { connect } from 'react-redux';
import { mapStateToPropsWrapper } from '../CaptureErreurs';
import { Link } from 'react-router-dom';
import * as VotesAct from '../../Actions/VoteActions';
import { obtenirVotantAvecVotesMAJ} from '../../App_Code/API';



class FicheVote extends Component {
    constructor(props) {
        super(props);

        this.state = {
          lsvotes: this.props.lsvotes,
          NumReunion: this.props.NumReu,
          NumOrdre: this.props.indexini,
          selectedOption: this.props.lsvotes[this.props.indexini].Vote,
          modif:false,
        };

    }
    componentWillMount() {
    }

    MasquerDiv = () => {
      this.setState({
        Voir: false,
      });
    }
    
    onVoteChange(vote) {
        const NumVote= this.state.lsvotes[this.state.NumOrdre].NumVoteForm;
        const NumReu= this.state.NumReunion;
        obtenirVotantAvecVotesMAJ(NumReu,NumVote,vote).then((data) => {
          this.setState({
            selectedOption: vote,
            modif:true,
            lsvotes: data.LsVotes,
          });
        });
       window.location.hash="#basDepage";

        const Ordre =this.state.NumOrdre
        let emplacement = ""
        if (Ordre==0) {emplacement="P"}
        if (Ordre==this.state.lsvotes.length-1) {emplacement="D"}
        if (emplacement=="D") {
          setTimeout(() => {
            document.getElementById("btnRetourListe").focus();
          }, "200");
        } else {
            if (vote!=0) {
              setTimeout(() => {
                document.getElementById("btnSuivant").focus();
              }, "200");
            };
        }
    }
    

    Suivant = () => {
       console.log ("Suivant")
      const Num=this.state.NumOrdre
      if (this.state.NumOrdre<this.state.lsvotes.length-1) {
        this.setState({
          NumOrdre: Num+1,
          selectedOption:this.state.lsvotes[Num+1].Vote,
        });
      }
      const Ordre =Num+1
      let emplacement = ""
      if (Ordre==0) {emplacement="P"}
      if (Ordre==this.state.lsvotes.length-1) {emplacement="D"}
      // if (emplacement=="D") {
      //   window.location.hash="#btnRetourListe";
      // } else {
        const liste = this.state.lsvotes;
        const vote=liste[Ordre]
        const TotTan=vote.TotTan
        const TypeVote=vote.TypeVote
        if (this.state.selectedOption!=0 || TotTan==0 || TypeVote==7) {
          window.location.hash="#btnSuivant";
        } else {
          window.location.hash="#basDepage";
        }
      // }
    }

    Precedent = () => {
      const Num=this.state.NumOrdre
      if ( this.state.NumOrdre>0) {
        this.setState({
          NumOrdre: Num-1,
          selectedOption:this.state.lsvotes[Num-1].Vote,
        });
      }
      window.location.hash="#basDepage";
    };

    SetNumReunion(NumR) {
      window.location.href = "/MesInformations/MonAG/" + NumR;
    }

    reinit = () => {
      // chargementComplet()
      console.log ("reinit")
      window.location.href = "/MesInformations/MonAG/" + this.state.NumReunion;
  
    };

    retourListe = () => {
      console.log ("retourliste")
      if ( this.state.modif) {
        this.reinit()
      } else {
        this.SetNumReunion(this.state.NumReunion)
      }
    };
  
  
    render() {
      const liste = this.state.lsvotes;
      const listereversed = this.state.lsvotes.concat().reverse();
      const Ordre =this.state.NumOrdre
      let emplacement = ""
      if (Ordre==0) {emplacement="P"}
      if (Ordre==this.state.lsvotes.length-1) {emplacement="D"}
      const vote=liste[Ordre]
      const Numvote=vote.NumVoteForm
      let LibellePrincipal =''
      let QuestionPrincipale =''
      if (vote.Numero2>0) {
        listereversed.forEach(element => {
          if (element.NumVoteForm<Numvote && LibellePrincipal ==='' ) {
            LibellePrincipal =`${element.Numero1} - ${element.Libelle}`
            QuestionPrincipale =`${element.ODJ_Txt}`
          }
        });
      }

        const {
            NumVoteForm, Numero1, Numero2, ODJ_Txt, Vote, Decision_Txt, TypeVote, Libelle, NumReunion, TotTan
        } = vote;
        return (
              <section id="section">
                <div className="acc-flex-container">
                  <div className="acc-why_choose_us">
                    {Numero2>0 ?
                        <div className="acc-panel card mb-3 acc-Reso-Principale">
                          <div className='small'>Rappel de la résolution principale</div>                            
                            <span ><h6 className="text-left" title={QuestionPrincipale}>{LibellePrincipal}</h6></span>
                      </div>
                    :''}
                    <h5 className="text-left"><span className={Numero2>0 ? `td-decale` : ``}>{Numero2==0 ? `${Numero1} - ` : `${Numero1} - ${Numero2} - `}
                                        {Libelle} </span></h5>
                      {ODJ_Txt.length>0 ?<div className="acc-panel card mb-3 acc-ul-div">
                          <span className="acc-noir acc-accordion-content">{ODJ_Txt}</span>
                      </div>:''}
                      <div className="acc-panel card mb-3 acc-ul-div">
                          <span className='acc-titre-reso'>Projet de résolution</span>
                        <div className="acc-accordion-content acc-police-forcee" dangerouslySetInnerHTML={{__html: Decision_Txt}}></div>
                      </div>
                      
                    {/* </ul> */}
                    {TypeVote==5 ?
                      <div  className="acc-panel card mb-3 acc-Reso-251">
                          <span ><h6 className="text-left small"><i className="fas fa-info-circle" style={{fontSize:"30px",color:"#2B78E4",paddingRight:"20px"}} />Il est necessaire de recuellir votre choix dans le cas où un second vote devrait avoir lieu</h6></span>
                          <div style={{fontSize:"0.6rem"}}> <b>Article 25-1 (extrait) : </b>Lorsque l’assemblée générale des copropriétaires n’a pas décidé à la majorité des voix de tous les copropriétaires,
                           en application de l’article 25 ou d’une autre disposition, 
                           mais que le projet a recueilli au moins le tiers de ces voix, 
                           la même assemblée se prononce à la majorité prévue à l’article 24 en procédant immédiatement à un second vote </div>                            
                      </div>
                    :''}
                    {TypeVote==6 ?
                      <div className="acc-flex-col-md-6  acc-Reso-251">
                          <span ><h6 className="text-left small"><i className="fas fa-info-circle" style={{fontSize:"30px",color:"#2B78E4",paddingRight:"20px"}} />Il est necessaire de recuellir votre choix dans le cas où un second vote devrait avoir lieu</h6></span>
                          <div style={{fontSize:"0.6rem"}}> <b>Article 26-1 (extrait) : </b>Nonobstant toute disposition contraire,
                           lorsque l’assemblée générale n’a pas décidé à la majorité prévue au premier alinéa de l’article 26 mais que le projet a au moins recueilli 
                           l’approbation de la moitié des membres du syndicat des copropriétaires présents, représentés ou ayant voté par correspondance, 
                           représentant au moins le tiers des voix de tous les copropriétaires, 
                           la même assemblée se prononce à la majorité des voix de tous les copropriétaires en procédant immédiatement à un second vote </div>                            
                      </div>
                    :''}
                  </div>
                </div>
                <div className='' style={{padding:"10px 7%"}}>
                  <div className="row" style={{display:"flex", justifyContent:"center"}}>
                      {TypeVote <7 && TotTan>0 ? 
                        <div style={{display:"flex", justifyContent:"center"}}> 
                        <Link
                            to={"#"} onClick={() => this.onVoteChange(1)} title='Pour'
                            className={this.state.selectedOption == "1" ? "btn btn-primary float-center mb-1 acc-vote-cb acc-vote-check1" : "btn btn-outline-primary acc-btn-vote float-center mb-1 acc-vote-cb acc-vote-nocheck1" } 
                            >
                              {this.state.selectedOption==1 ? <i className={'fas fa-check'} style={{paddingLeft:'10px',paddingRight:'5px'}} /> : ``}
                              Pour</Link>
                        <Link
                            to={"#"}  onClick={() => this.onVoteChange(2)} title='Contre'
                            className={this.state.selectedOption == "2" ? "btn btn-primary float-center mb-1 acc-vote-cb acc-vote-check2" : "btn btn-outline-primary acc-btn-vote float-center mb-1 acc-vote-cb acc-vote-nocheck2" } 
                            >
                              {this.state.selectedOption==2 ? <i className={'fas fa-check acc-vote-check'}  /> : ``}
                              Contre</Link>
                              <Link
                            to={"#"}  onClick={() => this.onVoteChange(3)} title='Abstention'
                            className={this.state.selectedOption == "3" ? "btn btn-primary float-center mb-1 acc-vote-cb acc-vote-check3" : "btn btn-outline-primary acc-btn-vote float-center mb-1 acc-vote-cb acc-vote-nocheck3" } 
                            >
                              {this.state.selectedOption==3 ? <i className={' fas fa-check acc-vote-check'}  /> : ``}
                              Abstention</Link>
                              <Link
                            to={"#"}  onClick={() => this.onVoteChange(0)} title='Annuler le vote'
                            className="btn btn-outline-primary acc-btn-vote float-center mb-1 acc-vote-efface"  
                            ><i className={'fas fa-eraser'} style={{paddingLeft:'10px',paddingRight:'5px'}} /></Link>
                        </div>
                         : 
                         <div className="text-center" style={{height:"42px"}}>
                          Pas de vote attendu. {TotTan<=0 ? ' Vous êtes non votant sur ce point.' :''}
                         </div> 
                        }
                    </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6 col-xl-4 ">
                        <div className=" mb-3"> 
                            <Link id='btnPrecedent'
                              to={"#"} onClick={() => this.Precedent() }
                              className={`btn btn-outline-primary float-right mb-1 acc-btn-goto ${emplacement==="P" ? 'acc-btn-desactive' : null }`}
                              ><i className="fa  fa-angle-left"></i><i className="fa  fa-angle-left"></i> Précédent</Link>
                          </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4 ">
                        <div className=" mb-3">
                          {emplacement!="D" ?
                          <Link  id='btnSuivant'
                          to={"#"} onClick={() => this.Suivant() }
                          className={`btn btn-outline-primary float-right mb-1 acc-btn-goto ${emplacement==="D" ? 'acc-btn-desactive' : null }`}
                          >Suivant <i className="fa  fa-angle-right"></i><i className="fa  fa-angle-right"></i></Link>
                      :
                          <Link  id='btnValider'
                              to={`/MesInformations/MonAG/MesVotes/MaSignature/${this.state.NumReunion}`}
                              className={`btn btn-success float-right mb-1 acc-btn-goto`}
                              >Valider</Link>
                          }
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4 ">
                        <div className=" mb-3">
                          <Link  id='btnRetourListe'
                              to={"#"} onClick={() => this.retourListe() }
                              // to={`/MesInformations/MonAG/${this.state.NumReunion}`}
                              className="btn btn-outline-primary float-right mb-1 acc-btn-goto"
                              ><i className='fa fa-list'></i> Retour à la liste {emplacement==="D" ? 'avant validation' : null }</Link>
                        </div>
                      </div>
                  </div>
                  <div id="basDepage">&nbsp;</div>
              </section>
        );
    };
}
FicheVote.displayName = 'FicheVote';

function mapStateToProps({ 
  CopStore: {
      Cop: { LsReunions },
  },
  VoteStore: { NumReuSel, Votant },
}) {
  return {NumReuSel, LsReunions };
}


function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(VotesAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(FicheVote);



// WEBPACK FOOTER //
// ./src/components/MonAG/FicheVote.js